export default "Info update: The person is wearing a diving suit and oxygen bottles.";